import { render } from "./downloadSection.vue?vue&type=template&id=2690a7ff"
import script from "./downloadSection.vue?vue&type=script&lang=js"
export * from "./downloadSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__